import Loadable from "@loadable/component";

const NeedHelpPage = Loadable(
  () => import(/* webpackChunkName: "need_help_page" */ "./help")
);

export default NeedHelpPage;
